import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProductsTab } from '@/app/(client)/network/-components/companyProfileTabs/products/ProductsTab';
import { useNetworkCompanyProducts } from '@/app/(client)/network/-hooks/useNetworkCompanyProducts';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/products',
)({
  validateSearch: searchSchema,
  component: ProductsRoute,
});

function ProductsRoute() {
  const { companyId } = Route.useParams();
  const { t, rows, total, isLoading, table, collectionMap } =
    useNetworkCompanyProducts(companyId);

  return (
    <ProductsTab
      rows={rows}
      total={total}
      isLoading={isLoading}
      table={{
        page: table.page,
        limit: table.limit,
        sorting: table.sorting,
        filters: table.filters,
        onSortingChange: table.onSortingChange,
        onFiltersChange: table.onFiltersChange,
        onPaginationChange: table.onPaginationChange,
      }}
      collectionMap={collectionMap}
      t={t}
    />
  );
}
